<template>
  	<FlexRechargeReport />
</template>

<script>

// @ is an alias to /src
import FlexRechargeReport from "@/components/reports/Flex/RechargeReport.vue";

export default {
  name: "FlexRechargeReportView",
  components: {
    FlexRechargeReport,
  },
};
</script>
